import moment from "moment-timezone";
import React from "react";
import { CalendarDaysPropsInterface } from "../../interfaces";
import { dateService } from "../../services";
import useCalendarStore from "../../store/calendar/calendar.store";

const CalendarDays: React.FC<CalendarDaysPropsInterface> = ({
  appointmentData,
}) => {
  const [day, nextDay] = useCalendarStore((state) => [
      moment(state.day),
      state.nextDay,
    ]),
    [matchedDates, setMatchedDates] = React.useState<string[]>([]),
    weekDays = dateService.getWeekDaysList(day);

  const handleSelectDay = (day: moment.Moment) => {
    nextDay(day);
  };

  React.useEffect(() => {
    const selectedDayAppointments =
      appointmentData != null
        ? Object.keys(appointmentData).filter((date) => {
            return moment(date).isBetween(
              day.startOf("day").format("YYYY-MM-DD"),
              day.endOf("day").format("YYYY-MM-DD"),
              undefined,
              "[]"
            );
          })
        : [];

    setMatchedDates(selectedDayAppointments);
  }, [appointmentData, setMatchedDates, day.format()]);

  const renderAppointments = (selectedDate: string, index: number) => {
    return (
      <div>
        {appointmentData[selectedDate].map((appointment, index) => (
          <div
            key={index}
            className="p-4 grid grid-cols-5 items-center justify-between border-b">
            <p className="flex items-center font-semibold gap-2 ">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.6667 4C10.6667 4.70724 10.3857 5.38552 9.88562 5.88562C9.38552 6.38572 8.70724 6.66667 8 6.66667C7.29276 6.66667 6.61448 6.38572 6.11438 5.88562C5.61428 5.38552 5.33333 4.70724 5.33333 4C5.33333 3.29276 5.61428 2.61448 6.11438 2.11438C6.61448 1.61428 7.29276 1.33333 8 1.33333C8.70724 1.33333 9.38552 1.61428 9.88562 2.11438C10.3857 2.61448 10.6667 3.29276 10.6667 4ZM8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8ZM16 14.6667C16 16 14.6667 16 14.6667 16H1.33333C1.33333 16 0 16 0 14.6667C0 13.3333 1.33333 9.33333 8 9.33333C14.6667 9.33333 16 13.3333 16 14.6667ZM14.6667 14.6613C14.6653 14.3333 14.4613 13.3467 13.5573 12.4427C12.688 11.5733 11.052 10.6667 8 10.6667C4.94667 10.6667 3.312 11.5733 2.44267 12.4427C1.53867 13.3467 1.336 14.3333 1.33333 14.6613H14.6667Z"
                  fill="#6b7280"
                />
              </svg>
              <span className="capitalize font-medium">
                {appointment.consumer.firstName} {appointment.consumer.lastName}
              </span>
            </p>
            <p className="flex items-center gap-2 text-grey-secondary2">
              <svg
                width="16"
                height="16"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.3869 0 9 0ZM9 16.5C7.51664 16.5 6.0666 16.0601 4.83323 15.236C3.59986 14.4119 2.63856 13.2406 2.07091 11.8701C1.50325 10.4997 1.35473 8.99168 1.64411 7.53682C1.9335 6.08196 2.64781 4.74559 3.6967 3.6967C4.7456 2.6478 6.08197 1.9335 7.53683 1.64411C8.99168 1.35472 10.4997 1.50325 11.8701 2.0709C13.2406 2.63856 14.4119 3.59985 15.236 4.83322C16.0601 6.06659 16.5 7.51664 16.5 9C16.5 10.9891 15.7098 12.8968 14.3033 14.3033C12.8968 15.7098 10.9891 16.5 9 16.5ZM12.1575 11.0925C12.236 11.1597 12.2998 11.2425 12.3448 11.3355C12.3898 11.4286 12.4151 11.5299 12.4191 11.6332C12.4231 11.7365 12.4057 11.8395 12.368 11.9357C12.3303 12.032 12.2731 12.1194 12.2 12.1925C12.1269 12.2656 12.0395 12.3228 11.9432 12.3605C11.847 12.3982 11.744 12.4156 11.6407 12.4116C11.5374 12.4076 11.4361 12.3823 11.343 12.3373C11.25 12.2923 11.1672 12.2285 11.1 12.15L8.475 9.525C8.33369 9.38653 8.25282 9.19783 8.25 9V3.75C8.25 3.55109 8.32902 3.36032 8.46967 3.21967C8.61032 3.07902 8.80109 3 9 3C9.19891 3 9.38968 3.07902 9.53033 3.21967C9.67099 3.36032 9.75 3.55109 9.75 3.75V8.6925L12.1575 11.0925Z"
                  fill="#6b7280"
                />
              </svg>
              <span>
                {dateService.convertUtcDateTimeToUserTimezone(
                  appointment.date,
                  appointment.startTime,
                  "hh:mm a"
                )}{" "}
                -{" "}
                {dateService.convertUtcDateTimeToUserTimezone(
                  appointment.date,
                  appointment.endTime,
                  "hh:mm a"
                )}
              </span>
            </p>
            <p className="text-grey-secondary2 capitalize">
              {appointment.appointmentType.name}
            </p>
            <p className="flex items-center gap-2 text-grey-secondary2">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.65436 1.32825C3.59532 1.25232 3.52081 1.18981 3.43577 1.14488C3.35072 1.09996 3.25709 1.07364 3.16109 1.06768C3.06509 1.06173 2.96893 1.07626 2.87898 1.11032C2.78903 1.14439 2.70736 1.1972 2.63939 1.26526L1.60542 2.30022C1.12244 2.78421 0.944441 3.46919 1.15543 4.07017C2.03115 6.55768 3.45566 8.81612 5.3233 10.678C7.18517 12.5456 9.4436 13.9701 11.9311 14.8458C12.5321 15.0568 13.2171 14.8788 13.701 14.3958L14.735 13.3619C14.8031 13.2939 14.8559 13.2122 14.8899 13.1223C14.924 13.0323 14.9385 12.9362 14.9326 12.8402C14.9266 12.7442 14.9003 12.6505 14.8554 12.5655C14.8105 12.4805 14.7479 12.4059 14.672 12.3469L12.3651 10.553C12.284 10.49 12.1896 10.4464 12.0891 10.4252C11.9887 10.4041 11.8847 10.4061 11.7851 10.431L9.59517 10.978C9.30286 11.051 8.99661 11.0471 8.70624 10.9667C8.41587 10.8863 8.15128 10.732 7.93822 10.519L5.4823 8.06204C5.26907 7.84909 5.11464 7.58454 5.03403 7.29417C4.95342 7.00379 4.94938 6.69749 5.02231 6.4051L5.5703 4.21516C5.5952 4.11556 5.59716 4.01161 5.57603 3.91114C5.5549 3.81067 5.51122 3.71631 5.4483 3.63518L3.65436 1.32825ZM1.88441 0.511279C2.0594 0.336234 2.26963 0.200419 2.50113 0.112853C2.73264 0.0252863 2.98012 -0.0120279 3.22715 0.00338793C3.47418 0.0188037 3.71511 0.0865968 3.93393 0.202265C4.15275 0.317934 4.34446 0.478832 4.49633 0.674274L6.29027 2.9802C6.61926 3.40319 6.73526 3.95417 6.60526 4.47416L6.05828 6.66409C6.03 6.77751 6.03153 6.89633 6.06272 7.00899C6.0939 7.12165 6.15369 7.22433 6.23628 7.30707L8.6932 9.76399C8.77603 9.84674 8.87889 9.90663 8.99174 9.93782C9.1046 9.96902 9.2236 9.97045 9.33718 9.94199L11.5261 9.395C11.7827 9.33084 12.0506 9.32586 12.3094 9.38043C12.5682 9.435 12.8112 9.54769 13.0201 9.70999L15.326 11.5039C16.155 12.1489 16.231 13.3739 15.489 14.1149L14.455 15.1488C13.715 15.8888 12.6091 16.2138 11.5781 15.8508C8.93937 14.9224 6.54354 13.4117 4.56833 11.4309C2.58768 9.45602 1.07705 7.06053 0.148466 4.42216C-0.213522 3.39219 0.111467 2.28522 0.851444 1.54525L1.88541 0.511279H1.88441Z"
                  fill="#6b7280"
                />
              </svg>

              <span>{appointment.consumer.mobileNumber}</span>
            </p>
            <div className="flex  items-center gap-8">
              <button
                className={`w-32 py-2 rounded-md text-white font-medium text-md capitalize ${
                  appointment.status === "CANCELLED"
                    ? "bg-gray-400"
                    : "bg-green-primary"
                }`}>
                {appointment.status.toLowerCase()}
              </button>
              <button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="gray"
                  className="w-5 h-5">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                  />
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="mx-6">
      <div className="flex justify-between items-center">
        {/* Week days */}
        {weekDays.map((weekDay, index) => (
          <div className="h-20 w-full text-center" key={index}>
            <p className="text-gray-500 mb-5">{weekDay.day}</p>
            <span
              onClick={() => handleSelectDay(weekDay.date)}
              className={`cursor-pointer ${
                weekDay.date.format("D") === day.date().valueOf().toString() &&
                "bg-primary text-gray-200 rounded-full p-2"
              }`}>
              {weekDay.date.format("DD")}
            </span>
          </div>
        ))}
      </div>
      {/* Appointments of selected day */}
      {matchedDates.length ? (
        <div className=" mt-3 border-t-2 flex flex-col bg-white h-screen ">
          {matchedDates.map((selectedDate, index) => (
            <div key={index}>{renderAppointments(selectedDate, index)}</div>
          ))}
        </div>
      ) : (
        <main className="flex flex-col items-center justify-center flex-1 space-y-4 overflow-y-auto">
          <div className="px-4 py-8 text-center sm:px-6">
            <h2 className="text-3xl font-medium text-gray-800 sm:text-4xl">
              No Appointments!
            </h2>
            <p className="max-w-md mt-4 text-gray-500">
              No upcoming appointments
            </p>
          </div>
        </main>
      )}
    </div>
  );
};

export default CalendarDays;
